import { useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import {
  DataIntegrationStepControlsContext,
  defaultControls,
  type DataIntegrationStepControls,
  type DataIntegrationStepControlsContextValue,
} from './index';

export function DataIntegrationStepControlsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [controls, setControls] =
    useState<DataIntegrationStepControls>(defaultControls);

  const value = useMemo<DataIntegrationStepControlsContextValue>(
    () => ({ controls, setControls }),
    [controls],
  );

  return (
    <DataIntegrationStepControlsContext.Provider value={value}>
      {children}
    </DataIntegrationStepControlsContext.Provider>
  );
}
